import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class Button extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        hasArrow: PropTypes.bool,
        name: PropTypes.string,
        noMenu: PropTypes.bool,
        onClickHandler: PropTypes.func,
        selected: PropTypes.bool,
        text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    }

    static defaultProps = {
        disabled: false,
        hasArrow: false,
        onClickHandler: () => {},
        selected: false,
        noMenu: false,
    }

    onClickHandler = (_e) => {
        const { name, onClickHandler } = this.props

        onClickHandler(name, _e)
    }

    render() {
        const { disabled, hasArrow, name, selected, text, noMenu } = this.props

        if (!name) return null

        // button can't be selected and disabled together
        const selectedAdjust = selected && disabled ? false : selected

        return (
            <div
                className={cx(
                    'drop-down-button',
                    `type-${name}`,
                    hasArrow && 'arrow',
                    noMenu && 'no-menu',
                    selectedAdjust && 'selected',
                    disabled && 'disabled'
                )}
                onClick={this.onClickHandler}
            >
                <div className={'icon'} />
                <div className={'text'}>{text}</div>
            </div>
        )
    }
}
